import { gql } from '@apollo/client'

export const GET_PRIORITY_STORE_EXPECTED_SALES = gql`
  query GetPriorityStoreExpectedSales($input: PicOSPriorityStoreInput!) {
    priorityStoreExpectedSales(input: $input) {
      date
      expectedSales
    }
  }
`
